import instance, { PPR_API_URL } from 'api';
import {
  IApplication,
  IDefectType,
  IDelayReason,
  IApplicationHistoryChangeStatus,
  IApplicationHistoryComment,
  IApplicationHistoryEdit,
  IApplicationHistoryProlongation,
  IPosition,
  IExecutor,
} from './interfaces';

export const loadApplicationPpr = (applicationItemId: number) => {
  return instance(true, PPR_API_URL)
    .get<IApplication>('application/loadItem/' + applicationItemId)
    .then((response) => response.data);
};

export const changeStatusApplicationPpr = (applicationItemId: number, data: IApplicationHistoryChangeStatus) => {
  return instance(true, PPR_API_URL)
    .post('application/addAction/' + applicationItemId, data)
    .then((response) => response.data);
};

export const addCommentToApplicationPpr = (applicationItemId: number, data: IApplicationHistoryComment) => {
  return instance(true, PPR_API_URL)
    .post('application/addAction/' + applicationItemId, data)
    .then((response) => response.data);
};

export const updateApplicationPpr = (
  applicationItemId: number,
  data: IApplicationHistoryEdit,
): Promise<IApplication> => {
  return instance(true, PPR_API_URL)
    .post('/application/addAction/' + applicationItemId, data)
    .then((response) => response.data);
};

export const prolongApplicationPpr = (applicationItemId: number, data: IApplicationHistoryProlongation) => {
  return instance(true, PPR_API_URL)
    .post('application/addAction/' + applicationItemId, data)
    .then((response) => response.data);
};

// dictionary
export const getDefectTypes = () => {
  return instance(true, PPR_API_URL)
    .get<IDefectType[]>('/dictionary/defectType/listAll')
    .then((response) => response.data);
};

export const getDelayReasons = (defectTypeId: number) => {
  return instance(true, PPR_API_URL)
    .get<IDelayReason[]>('/dictionary/delayReason/listAll', { params: { defectTypeId } })
    .then((response) => response.data);
};

export const getExecutorPositionsByDefectTypeId = (defectTypeId: number) => {
  return instance(true, PPR_API_URL)
    .get<IPosition[]>(`/dictionary/defectType/getAssigneePositions/${defectTypeId}`)
    .then((response) => response.data);
};

export const getExecutorsByPositionId = (areaId: number, positionId: number) => {
  return instance(true, PPR_API_URL)
    .get<IExecutor[]>(`/matrix/findExecutor/${areaId}/${positionId}`)
    .then((response) => response.data);
};
